module.exports = __webpack_public_path__ + "img/20230218160717932hxk.de29ff77.png";